export default "__VITE_ASSET__eff10914__"